// Mock data for Mind Motion Physiotherapy website

export const clinicInfo = {
  name: "Mind Motion Physiotherapy and Rehab Center",
  tagline: "Pain → Recovery → Movement",
  description: "Personalised physiotherapy. Evidence-led. Local to Bellandur.",
  phone: "+91 90085 41255",
  whatsapp: "+91 90085 41255",
  email: "contact@mindmotionphysio.com",
  locations: [
    {
      id: 1,
      name: "Bellandur Clinic",
      address: "10/2A, Bellandur Gate, Sarjapur Road, Bellandur, Bangalore - 560103",
      landmark: "Near Eco Space IT Park",
      mapLink: "https://maps.google.com/?q=10/2A+Bellandur+Gate+Sarjapur+Road",
      hours: "Mon-Sat: 9:00 AM - 7:00 PM"
    }
  ]
};

// Hero carousel slides with Indian client personas
export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1576091160550-112173f31c77?w=1200&q=80",
    title: "Pain → Recovery → Movement",
    subtitle: "Expert care for IT professionals with desk-related pain"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1631217852540-cf61a9661b0b?w=1200&q=80",
    title: "Pain → Recovery → Movement",
    subtitle: "Personalized treatment for homemakers with daily activity pain"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1576262981271-38baf0ef8d9b?w=1200&q=80",
    title: "Pain → Recovery → Movement",
    subtitle: "Specialized care for young professionals returning to active life"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1631217852433-4ba75bced63d?w=1200&q=80",
    title: "Pain → Recovery → Movement",
    subtitle: "Expert rehabilitation for experienced professionals"
  }
];

// Real clinic images
export const clinicImages = {
  equipment: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/52t8jmh3_WhatsApp%20Image%202026-02-13%20at%206.49.49%20PM%20%282%29.jpeg",
  treatmentRoom1: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/lao90awx_WhatsApp%20Image%202026-02-13%20at%206.49.49%20PM%20%281%29.jpeg",
  facility: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/qwrk3wsz_WhatsApp%20Image%202026-02-13%20at%206.49.49%20PM.jpeg",
  treatmentRoom2: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/i4q9wdib_WhatsApp%20Image%202026-02-13%20at%206.49.48%20PM%20%282%29.jpeg",
  exerciseArea: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/6ncfctz1_WhatsApp%20Image%202026-02-13%20at%206.49.48%20PM%20%281%29.jpeg"
};

export const drRupesh = {
  name: "Dr. Rupesh Kumar",
  qualification: "BPT, MPT (neurology), Certified Manual Therapist",
  experience: "4+ years",
  specialization: "Adult Neurology",
  philosophy: "I believe in treating the root cause, not just the symptoms. Every patient deserves a personalized recovery plan that respects their lifestyle, goals, and pace of healing.",
  image: "https://customer-assets.emergentagent.com/job_9ff3fdb6-e98f-4808-aca2-2fa45b9171c3/artifacts/lxa8etz3_WhatsApp%20Image%202026-02-13%20at%206.49.40%20PM.jpeg"
};

export const whyMindMotion = [
  {
    id: 1,
    title: "Clinical Expertise",
    description: "Evidence-based protocols backed by 12+ years of orthopedic and sports rehabilitation experience",
    icon: "Award"
  },
  {
    id: 2,
    title: "Hands-On Care",
    description: "One-on-one sessions with personalized treatment plans, not generic exercise sheets",
    icon: "Hand"
  },
  {
    id: 3,
    title: "Proven Outcomes",
    description: "Track record of helping patients return to pain-free movement and active lifestyles",
    icon: "TrendingUp"
  }
];

// Helpful Resources - Home Treatment Plans
export const helpfulResources = [
  {
    id: 1,
    title: "IT Professional's Recovery Guide",
    description: "Head, neck, and shoulder strengthening exercises for desk workers",
    category: "Occupational Health",
    downloadLink: "/resources/htp-it-professional.pdf",
    icon: "Laptop"
  },
  {
    id: 2,
    title: "Homemaker's Wellness Plan",
    description: "Daily exercises for managing household activity-related pain",
    category: "Daily Living",
    downloadLink: "/resources/htp-homemaker.pdf",
    icon: "Home"
  },
  {
    id: 3,
    title: "50+ Active Living Guide",
    description: "Age-appropriate exercises for maintaining mobility and strength",
    category: "Senior Wellness",
    downloadLink: "/resources/htp-senior.pdf",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Back Pain Relief Program",
    description: "Comprehensive exercises for lower back pain management",
    category: "Pain Management",
    downloadLink: "/resources/htp-back-pain.pdf",
    icon: "Move"
  },
  {
    id: 5,
    title: "Neck & Shoulder Care",
    description: "Targeted exercises for tech neck and shoulder tension",
    category: "Upper Body",
    downloadLink: "/resources/htp-neck-shoulder.pdf",
    icon: "User"
  },
  {
    id: 6,
    title: "Knee Strengthening Routine",
    description: "Progressive exercises for knee stability and pain relief",
    category: "Lower Body",
    downloadLink: "/resources/htp-knee.pdf",
    icon: "Activity"
  },
  {
    id: 7,
    title: "Post-Surgery Recovery",
    description: "Guided rehabilitation exercises for post-operative care",
    category: "Rehabilitation",
    downloadLink: "/resources/htp-post-surgery.pdf",
    icon: "Stethoscope"
  },
  {
    id: 8,
    title: "Sports Injury Prevention",
    description: "Warm-up and strengthening routines for athletes",
    category: "Sports Health",
    downloadLink: "/resources/htp-sports.pdf",
    icon: "Zap"
  }
];

export const conditions = [
  {
    id: 1,
    name: "Upper Back Pain",
    shortDesc: "Postural pain, muscle tension, thoracic spine issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Move",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80",
    bodyPart: "upper-back"
  },
  {
    id: 2,
    name: "Lower Back Pain",
    shortDesc: "Chronic back pain, sciatica, disc problems, lumbar issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Move",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80",
    bodyPart: "lower-back"
  },
  {
    id: 3,
    name: "Knee Pain",
    shortDesc: "Osteoarthritis, ligament injuries, post-surgical rehabilitation",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "CircleDot",
    image: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=600&q=80",
    bodyPart: "knee"
  },
  {
    id: 4,
    name: "Ankle Pain",
    shortDesc: "Sprains, instability, post-injury rehabilitation",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",
    bodyPart: "ankle"
  },
  {
    id: 5,
    name: "Neck Pain & Stiffness",
    shortDesc: "Cervical spondylosis, tech neck, postural issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "User",
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&q=80",
    bodyPart: "neck"
  },
  {
    id: 6,
    name: "Shoulder Pain",
    shortDesc: "Frozen shoulder, rotator cuff injuries, impingement",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "User",
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&q=80",
    bodyPart: "shoulder"
  },
  {
    id: 7,
    name: "Sports Injuries",
    shortDesc: "ACL tears, sprains, muscle strains, athletic performance recovery",
    category: "sports",
    categoryName: "Sports Rehabilitation",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",
    bodyPart: "full-body"
  },
  {
    id: 8,
    name: "Neurological Conditions",
    shortDesc: "Stroke recovery, nerve injuries, balance issues",
    category: "specific",
    categoryName: "Specific Conditions",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80",
    bodyPart: "neurological"
  },
  {
    id: 9,
    name: "Post-Operative Care",
    shortDesc: "Joint replacements, fracture recovery, surgical rehabilitation",
    category: "specific",
    categoryName: "Specific Conditions",
    icon: "Stethoscope",
    image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&q=80",
    bodyPart: "post-op"
  },
  {
    id: 10,
    name: "Work-Related Injuries",
    shortDesc: "Repetitive strain, carpal tunnel, desk posture correction",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80",
    bodyPart: "upper-body"
  }
];

export const treatmentDetails = {
  1: {
    name: "Back Pain & Spine Issues",
    painPoints: [
      "Persistent lower back pain affecting daily activities",
      "Sciatica radiating down the leg",
      "Difficulty sitting or standing for long periods",
      "Morning stiffness and reduced mobility"
    ],
    approach: "We use a combination of manual therapy, core strengthening, and postural correction to address the root cause of your spine issues. Our evidence-based protocols focus on long-term relief, not temporary fixes.",
    recoveryPath: [
      { phase: "Week 1-2", focus: "Pain relief and mobility restoration" },
      { phase: "Week 3-4", focus: "Core strengthening and stability" },
      { phase: "Week 5-8", focus: "Functional movement and prevention" }
    ],
    outcomes: "85% of our back pain patients report significant improvement within 6-8 weeks"
  },
  2: {
    name: "Sports Injuries",
    painPoints: [
      "Sudden injury during sports or exercise",
      "Recurring pain limiting athletic performance",
      "Post-surgery return to sport concerns",
      "Loss of strength and mobility"
    ],
    approach: "Sport-specific rehabilitation that gets you back to your game stronger. We combine therapeutic exercises, manual therapy, and progressive loading protocols tailored to your sport.",
    recoveryPath: [
      { phase: "Week 1-3", focus: "Healing and pain management" },
      { phase: "Week 4-6", focus: "Strength and range of motion" },
      { phase: "Week 7-12", focus: "Sport-specific training and prevention" }
    ],
    outcomes: "Athletes return to their sport with reduced re-injury risk and improved performance"
  },
  3: {
    name: "Knee Pain",
    painPoints: [
      "Pain while climbing stairs or walking",
      "Swelling and stiffness in the knee joint",
      "Difficulty kneeling or squatting",
      "Instability or giving way sensation"
    ],
    approach: "Comprehensive knee rehabilitation focusing on strengthening surrounding muscles, improving joint mechanics, and restoring pain-free movement patterns.",
    recoveryPath: [
      { phase: "Week 1-2", focus: "Reduce inflammation and pain" },
      { phase: "Week 3-6", focus: "Strengthen quadriceps and hamstrings" },
      { phase: "Week 7-10", focus: "Functional activities and stability" }
    ],
    outcomes: "Patients experience improved mobility and return to daily activities without pain"
  }
};

export const howItWorks = [
  {
    step: 1,
    title: "Comprehensive Assessment",
    description: "Detailed evaluation of your condition, movement patterns, and lifestyle factors",
    icon: "ClipboardList"
  },
  {
    step: 2,
    title: "Personalised Treatment Plan",
    description: "Evidence-based protocol tailored to your specific needs and recovery goals",
    icon: "FileText"
  },
  {
    step: 3,
    title: "Guided Recovery Sessions",
    description: "One-on-one therapy with hands-on techniques and progressive exercises",
    icon: "Users"
  },
  {
    step: 4,
    title: "Back to Movement",
    description: "Return to pain-free daily activities with strategies to prevent recurrence",
    icon: "CheckCircle"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    condition: "Chronic Back Pain",
    text: "After 2 years of trying different treatments, Dr. Rupesh finally helped me understand the root cause. The personalized exercises and manual therapy made a huge difference. I'm back to my morning walks pain-free!",
    rating: 5,
    location: "Bellandur"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    condition: "Post-ACL Surgery",
    text: "The sports rehab program here is exceptional. Dr. Rupesh guided me through every phase of recovery. I'm back playing football within 6 months, stronger than before.",
    rating: 5,
    location: "Sarjapur"
  },
  {
    id: 3,
    name: "Anita Menon",
    condition: "Frozen Shoulder",
    text: "I couldn't lift my arm above shoulder level for months. The treatment here was patient-centered and effective. Now I have full range of motion back!",
    rating: 5,
    location: "Bellandur"
  },
  {
    id: 4,
    name: "Vikram Reddy",
    condition: "Knee Osteoarthritis",
    text: "Was considering surgery for my knee pain. Dr. Rupesh's conservative treatment approach saved me from that. Climbing stairs is no longer painful.",
    rating: 5,
    location: "Sarjapur"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long is each session?",
    answer: "Each one-on-one session typically lasts 45-60 minutes, allowing adequate time for manual therapy, guided exercises, and personalized attention."
  },
  {
    id: 2,
    question: "How many sessions will I need?",
    answer: "It varies based on your condition. Acute issues may resolve in 4-6 sessions, while chronic conditions might need 8-12 sessions. We'll provide a clear timeline after your initial assessment."
  },
  {
    id: 3,
    question: "Do you accept insurance?",
    answer: "Yes, we provide detailed invoices that you can submit to your insurance provider for reimbursement. We work with most major insurance companies."
  },
  {
    id: 4,
    question: "What should I bring to my first appointment?",
    answer: "Please bring any recent medical reports, imaging results (X-rays, MRI), and wear comfortable clothing that allows easy movement."
  },
  {
    id: 5,
    question: "Do you treat sports injuries?",
    answer: "Absolutely. We specialize in sports rehabilitation and work with athletes of all levels to ensure safe return to sport with reduced injury risk."
  }
];
